export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404a0b25f3a040b50597ac0be9a6c4cad114985b94&name=revalidateCommunity!'